import type { Nullable } from '@clearverify/types';

import type { DroppedFile } from 'src/types/file';

export const validateMaxTotalFilesSize = (maxTotalSize: Nullable<number>, files: DroppedFile[]) => {
  if (!maxTotalSize) {
    return true;
  }

  const totalSize = files.reduce((totalSize, file) => totalSize + file.size * 1e-6, 0);
  return maxTotalSize > totalSize;
};
